export const serviceInfo=  {
    "1": {
        name: "拖吊",
        questions: [
            {
                label: "可將車輛打到 N 檔嗎？", key: 'car_gear',
                option: [
                    { name: "可以", id: "1", value: true, text:"可排空(N)檔" },
                    { name: "不行", id: "2", value: false, text:"不行" }]
            },
            {
                label: "手煞車是可以放開的嗎？",key: "car_handbrake",
                option: [
                    { name: "可以", id: "1", value: true, text:"可放" },
                    { name: "不行", id: "2", value: false , text:"不能放"}]
            },
            {
                label: "輪胎有破損嗎？",key: "flat_tire",
                option: [
                    { name: "沒有", id: "1", value: "無" },
                    { name: "前輪", id: "2", value: "前輪" },
                    { name: "後輪", id: "3", value: "後輪" },
                    { name: "前後皆破", id: "4", value: "前後都破" },
                ]
            },
            {
                label: "現場是事故嗎？", key: "is_accident",
                option: [
                    { name: "是", id: "1", value: true },
                    { name: "否", id: "2", value: false }]
            },
            {
                label: "會跟車前往拖吊目的地嗎？",
                key: "follow_car",
                option: [
                    { name: "會", id: "1", value: true },
                    { name: "不會", id: "2", value: false }]
            },
            {
                label: "車上是否有載貨物？",
                desc: "服務以空車為主，若車上有載貨，會由技師現場判斷載貨的量，跟您報價收費",
                key: "is_cargo",
                // type: "switch",
                // values:{true:'Y', false:'N'},
                option: [
                    { name: "是", id: "1", value: true },
                    { name: "否", id: "2", value: false },]
            },
        ]
    },
    "2":{  name: "送水"},
    "3": {
        name: "送油",
        questions: [
            {
                label: "您的車輛加油時需要洩壓嗎？可以自行洩壓？",
                key: 'can_self_relief',
                disabled: {
                    value: false,
                    title: "無法自行洩壓？",
                    description: "若無法由您進行洩壓，將無法提供送油服務，建議您改使用拖吊服務。",
                    okText: "改拖吊",
                    btn02Text: "取消服務",
                },
                option: [
                    { name: "不需洩壓", id: "0", value: true },
                    { name: "可自行洩壓", id: "1", value: true },
                    { name: "無法自行洩壓", id: "2", value: false }]
            },
            {
                label: "需要什麼樣的油品？",
                key: 'gasoline',
                desc:"油資費用無法刷卡，技師將憑加油站發票，現場向您收取現金（200 元內）",
                option: [
                    { name: "92無鉛", id: "1", value: "92無鉛汽油" },
                    { name: "95無鉛", id: "2", value: "95 無鉛汽油" },
                    { name: "98無鉛", id: "3", value: "98 無鉛汽油" },
                    { name: "超級柴油", id: "3", value: "超級柴油" }]
            },
            {
                label: "油資要開統一編號嗎？",
                key: 'is_tax_id',
                option: [
                    { name: "要", id: "1", value: true },
                    { name: "不需要", id: "2", value: false },],
                sub: {
                    type: "input",
                    key: "tax_id_number",
                    label: "",
                    value: true,
                    rules:   [{ pattern: new RegExp(/^[1-9]\d{7}$/), message: '請輸入長度為8碼的輸入統一編號' }],
                   
                    placeholder:"請輸入統一編號"
                }
            },
        ]
    },
    "4":{  name: "接電"},
    "5": {
        name: "更換備胎",
        questions: [
            {
                label: "有足夠的備胎可供更換嗎？",
                
                key: 'has_spare_tire',
                disabled: {
                    value: false,
                    title: "沒有備胎嗎？",
                    description: "若沒有備胎，將無法提供輪胎更換服務，建議您改使用拖吊服務。",
                    okText: "改拖吊",
                    btn02Text: "取消服務",
                },
                option: [
                    { name: "有", id: "1", value: true },
                    { name: "沒有", id: "2", value: false }]
            },
            {
                label: "有更換備胎的工具嗎？",
                desc:<>
                    技師攜帶標準工具，可協助一般輪胎更換。<br/>
                    防盜螺絲或螺帽輪胎需自備更換工具，否則僅能安排拖吊。
                </>,
                key: 'has_dismount_tools',
                option: [
                    { name: "有", id: "1", value: true },
                    { name: "沒有", id: "2", value: false }]
            },
            {
                label: "現場是事故嗎？",
                key: 'is_accident',
                option: [
                    { name: "是", id: "1", value: true },
                    { name: "否", id: "2", value: false },]
            },
        ]
    },
    "6": {
        name: "調離坑洞或沙堆",
        questions: [
            {
                label: "吊離受困點後需要將車輛拖吊去別處嗎？",
                key: 'is_towed_to',
                sub: {
                    type:"option",
                    value: true,
                    question: {
                        label: "會跟車前往拖吊目的地嗎？",
                        key: 'follow_car',
                        option: [
                            { name: "會", id: "1", value: true },
                            { name: "不會", id: "2", value: false }
                        ]
                    }
                },
                option: [
                    { name: "需要", id: "1", value: true },
                    { name: "不需要", id: "2", value: false }]
            },
            {
                label: "輪胎有破損嗎？",
                key: "flat_tire",
                option: [
                    { name: "沒有", id: "1", value: "無" },
                    { name: "前輪", id: "2", value: "前輪" },
                    { name: "後輪", id: "3", value: "後輪" },
                    { name: "前後皆破", id: "4", value: "前後都破" },
                ]
            },
            {
                label: "現場是事故嗎？",
                key: 'is_accident',
                option: [
                    { name: "是", id: "1", value: true },
                    { name: "否", id: "2", value: false },]
            },
            {
                label: "車上是否有載貨物？",
                desc: "服務以空車為主，若車上有載貨，會由技師現場判斷載貨的量，跟您報價收費",
                key: "is_cargo",
                // type: "switch",
                // values:{true:'Y', false:'N'},
                option: [
                    { name: "是", id: "1", value: true },
                    { name: "否", id: "2", value: false },]
            }
        ]
    }
}